export default __webpack_public_path__ + "static/media/DNo.16-2.5de3b23d.jpg";